// extracted by mini-css-extract-plugin
export default {"ant-card-meta-title":"RecentUpdates_ant-card-meta-title__stMZD","birthday-card-wrapper":"RecentUpdates_birthday-card-wrapper__np0t-"};